@if (commands(); as commands) {
  <a
    data-testid="plan-info-overview-link"
    [routerLink]="commands"
    class="text-accent-main hover:text-accent-hover inline-flex cursor-pointer items-center gap-1 text-xs font-medium whitespace-nowrap hover:underline">
    {{ 'features.plan.panel.plan_info.overview' | translate }}
    <i [class]="ICONS.arrowRight" aria-hidden="true"></i>
  </a>
}
